import { NotFoundPageLabels } from 'libs/shared-lib/interfaces/partner-web/not-found-page';

export const NOT_FOUND_LABELS_IT: NotFoundPageLabels = {
    headline: '404',
    copy: 'La pagina richiesta non è stata trovata.',
    ctaPostText: 'Continuare a',
};
